import "../franquias-fotos-view-mobile/franquias-fotos-view-mobile.css";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ref, uploadBytes, getDownloadURL, listAll, list, } from "firebase/storage";
import { storage } from "../../services/firebaseConfig.js";
import { dadosLogin } from "../../zustand/zuztand.js"

import api from "../../services/api.js";


function FranquiasFotosViewMobile() {

    const [imageUrls, setImageUrls] = useState([]);
    const [dadosUrl, setDadosUrl] = useState([]);
    const [url_imgagem_franquia, setUrl_imgagem_franquia] = useState("");
    const [pastaStorage, setPastaStorage] = useState("");
    const [atualiza, setAtualiza] = useState(false);
    const [id_pesq, setId_pesq] = useState(parseInt(localStorage.getItem('idFranquia')));
    const navigate = useNavigate();
    const { ifLogado } = dadosLogin();

    const [codigo, setCodigo] = useState(0);
    const [razao_franquia, setRazao_franquia] = useState("");
    const [cidade_franquia, setCidade_franquia] = useState("");
    const [texto, setTexto] = useState("");
    const [escolha, setEscolha] = useState(true);
    const [url_doc_fornecedor, setUrl_doc_fornecedor] = useState("");
    const [dadosFranquiasCidades, setDadosFranquiasCidades] = useState([]);
    const [buscaAbrang, setBuscaAbrang] = useState("");


    const dadosUrlDow = [
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimages%2F1%2Fmodelo.jpg1723076336233?alt=media&token=05651ca1-09a1-4fe9-a108-937fb734baf9' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimages%2F1%2Fmodelo5.jpg1723068749279?alt=media&token=8dad1c2f-7393-4c37-a398-92c2edd910ce' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimg_franquias%2FCl_colombo.png?alt=media&token=6ff9c680-09fc-4a3f-8bf7-6221edf42f17' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimg_franquias%2FCl_primaveraDoLeste.png?alt=media&token=4f77f301-8b66-49d0-883a-97cc98864735' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimages%2F1%2Fmodelo.jpg1723076336233?alt=media&token=05651ca1-09a1-4fe9-a108-937fb734baf9' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimages%2F1%2Fmodelo5.jpg1723068749279?alt=media&token=8dad1c2f-7393-4c37-a398-92c2edd910ce' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimg_franquias%2FCl_colombo.png?alt=media&token=6ff9c680-09fc-4a3f-8bf7-6221edf42f17' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Farquivos%2F13%2FOutras%2F2024-06-11%20(1).jpg?alt=media&token=e1c671ce-5f90-4209-be9c-179fdea618df' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Farquivos%2F13%2FOutras%2F35m.jpeg?alt=media&token=37579942-a700-4d26-b193-b95439930ce8' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Farquivos%2F13%2FOutras%2Fsite-16jpeg-thumb.jpg?alt=media&token=415486c6-08a7-4708-93ac-06408ac5c10b' },
        { url: 'https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Farquivos%2F13%2FOutras%2F2024-06-11.jpg?alt=media&token=cae23498-dc68-4662-91a8-4035b27c3121' }
    ]


    function AtualiZaListaUrlIdDigitado() { //atualiza lista vindo do storage
        setImageUrls([])
        const imagesListRef3 = ref(storage, `franquias/arquivos/${localStorage.getItem('id_franquia')}/${pastaStorage}/`);  //pasta do storage que estao as imagens ex:fornecedores/arquivos/2/

        var dadosUrlDow = []
        listAll(imagesListRef3).then((response) => {
            response.items.forEach((item) => {
                getDownloadURL(item).then((url) => {
                    setImageUrls((prev) => [...prev, url]);
                    //console.log(url)
                    dadosUrlDow.push({
                        url
                    })
                });
            });
            //setImageUrls(dadosUrlDow)
            setDadosUrl(dadosUrlDow)
            //console.log(dadosUrl)
        });
    }


    function PegarUrl_franquia(url) {
        setUrl_imgagem_franquia(url)
    }

    function ChangePastaStorage(e) {//para selecionar no combobox a pasta onde seará salvo ao arquivo no firebase
        setPastaStorage(e.target.value);
        setAtualiza(!atualiza)
    };

    function ChangeId_pesq(e) {
        setId_pesq(e.target.value);
        localStorage.setItem('id_pesq', e.target.value);
    }
    function usar() {
        setId_pesq(codigo)
        setAtualiza(!atualiza)
        setCidade_franquia("")
        setRazao_franquia("")
        setTexto("")
        ListarFranquiasCidade()
    }


    function ListarFranquiasCidade() {//somente id e nome para montar combo
        setDadosFranquiasCidades([])
        api.get("/franquia_busca_abrang/", { params: { buscaAbrang } })
            .then((resp) => {
                setDadosFranquiasCidades(resp.data);
            })
            .catch((err) => {
                setDadosFranquiasCidades([]);
                alert("Erro ao carregar dados");
            });
    }

    function ChangeId_franquia(e) {
        let yy = e.target.value
        let gg = yy.split('/')
        setCodigo(gg[0])
        setCidade_franquia(gg[1])
        setRazao_franquia(gg[2])
    }

    useEffect(() => {
        const imagesListRef3 = ref(storage, `franquias/arquivos/${localStorage.getItem('id_franquia')}/${pastaStorage}/`);  //pasta do storage que estao as imagens ex:fornecedores/arquivos/2/
        var dadosUrlDow = []
        setImageUrls([])
        listAll(imagesListRef3).then((response) => {
            response.items.forEach((item) => {
                getDownloadURL(item).then((url) => {
                    setImageUrls((prev) => [...prev, url]);
                    //console.log(url)
                    dadosUrlDow.push({
                        url
                    })
                });
            });
            //console.log(dadosUrlDow)
            setDadosUrl(dadosUrlDow)
            setUrl_imgagem_franquia('')
            // console.log(imageUrls)
        });
    }, [atualiza]);




    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
    };

    return <>

        <div className="image-cards-container">
            {/* Barra superior */}
            <div className="top-bar d-flex justify-content-between align-items-center">
                <div className="title">
                <small className="form-control" value={localStorage.getItem('id_franquia')}>Cód: {localStorage.getItem('id_franquia')} - {localStorage.getItem('nome_franquia')} </small>
                </div>
                <div className=" d-flex">
                        <select type="text" className="form-control" onChange={ChangePastaStorage}>
                            <option value="">Selecione</option>
                            <option value="Inalguração">Inalguração</option>
                            <option value="Eventos">Eventos</option>
                            <option value="Visitas">Visitas</option>
                            <option value="Outras">Outras</option>
                        </select>
                        <span className="input-group-addon222">
                            <button className="bi bi-arrow-clockwise btn-id-select-mobile text-white" onClick={AtualiZaListaUrlIdDigitado}>
                            </button>
                        </span>
                    </div>
                <div className="buttons">              
                   
                    <button className="btn btn-primary" onClick={() => { navigate("/franquias-mobile") }}>Voltar</button>
                </div>
            </div>

            {/* Container com scroll horizontal */}
            <div className="cards-scroll-container mt-4">
                {dadosUrl.map((image, index) => (
                    <div key={index} className="card-horizontal m-2">
                        <img src={image.url} className="card-img-top" alt={`Imagem ${index + 1}`} />

                    </div>
                ))}
            </div>
        </div>

    </>

}
export default FranquiasFotosViewMobile;



